<template>
  <div class="questions-two text-animationFade">
    <div v-appear class="questions-two__block">
      <span class="questions-two__title">
        {{ left.title }}
      </span>
      <ul
        v-for="(item, index) in left.list"
        :key="index"
        class="questions-two__items"
        v-html="renderHtml(item)"
      />
    </div>
    <div v-appear class="questions-two__block">
      <span class="questions-two__title questions-two__title-string">
        {{ right.title }}
      </span>
      <ul
        v-for="(item, index) in right.list"
        :key="index"
        class="questions-two__items"
        v-html="renderHtml(item)"
      />
    </div>
  </div>
</template>

<script>
import FramedTextRenderItem from './FramedText/FramedTextRenderItem';

export default {
  name: 'QuestionsTwoBlocks',
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  computed: {
    left() {
      return this.params.frameLeft.frame;
    },
    right() {
      return this.params.frameRight.frame;
    },
  },
  methods: {
    renderHtml(item) {
      return FramedTextRenderItem(item);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/style/mobileFirst';

.questions-two {
  margin-bottom: 39px;

  @media (min-width: $tablet) {
    margin-bottom: 30px;
    display: flex;
  }

  @media (min-width: $desktop) {
    padding: 0 20px;
    margin-bottom: 150px;
  }

  @media (min-width: $desktop-l) {
    padding: 0;
  }

  &__string {
    @media (min-width: $desktop) {
      display: inline-block;
      width: 320px;
    }

    @media (min-width: $desktop-l) {
      display: inline;
    }
  }

  &__block {
    border: 1px solid $GrayBTN;
    border-bottom: none;
    padding: 27px 10px 22px;
    min-height: 240px;

    &:last-child {
      border-bottom: 1px solid $GrayBTN;
    }

    @media (min-width: $tablet) {
      border: 1px solid $GrayBTN;
      flex: 0 0 50%;
      padding: 27px 20px 22px;

      &:first-child {
        border-right: none;
      }
    }

    @media (min-width: $desktop) {
      padding: 57px 10px 22px 30px;
    }

    @media (min-width: $desktop-l) {
      padding: 57px 20px 22px 50px;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 13px;
    display: block;

    @media (min-width: $desktop) {
      font-size: 19px;
      margin-bottom: 16px;
    }
  }

  &__title-string {
    @media (min-width: $desktop) {
      width: 350px;
    }

    @media (min-width: $desktop-l) {
      width: 499px;
    }
  }

  &__items {
    padding: 0;

    li {
      list-style: none;
      font-weight: 400;
      font-size: 16px;
      margin-bottom: 13px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
